import styled from 'styled-components';

const AccordionPadding = styled.div`
  padding: ${({ isDesktop }) => (isDesktop ? '2% 1% 4% 1%' : '2% 5% 30px')};
`;

export default AccordionPadding;
